import React from 'react';

const Services = ({data}) => {

    return (
        <div className='container'>
            <div className='policy_section_wrapper'>
                <h1 className=''>{data.title}</h1>
                {data.sub_title ? <p className={'sub_title'}>{data.sub_title}</p> : null}
                {data.description ? <p className={'description_text'}>{data.description}</p> : null}
                {data.links ? <p className={'text_with_links'}>{data.links.text} <a href={data.links.link_1.url}>{data.links.link_1.text}</a> and <a href={data.links.link_2.url}>{data.links.link_2.text}</a></p> : null}
                {data.list.map((item, i) => {
                    return (
                        <div className="policy_section_item" key={item.title + i}>
                            <h2 className={'main_title'}>{item.title}</h2>
                            {item.sub_title ? <h3 className={'sub_title'}>{item.sub_title}</h3> : null}
                            {item.sub_title_2 ? <h3 className={'sub_title'}>{item.sub_title_2}</h3> : null}
                            {item.sub_title_3 ? <h3 className={'sub_title'}>{item.sub_title_3}</h3> : null}
                            {item.list.length ? <ul> {item.list.map((el, i) => {
                                return (
                                    <li className='main_text_style' key={i}>{el}</li>
                                )
                            })}
                            </ul> : null}
                            {item.post.length ? item.post.map((el, i) => {
                                return (
                                    <p className='main_text_style' key={i}>{el}</p>
                                )
                            }) : null}
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default Services;